import React from "react";
import { useSelector } from "react-redux";
import AboutUsSection from "../../components/about/AboutUS";
import ServicesSubPages from "./ServicesSubPages";
import Rimg1 from "../../assest/Residentails-1.png";
import Rimg2 from "../../assest/Residental-2.png";
import Rimg3 from "../../assest/Residenatl-3.png";
import ServicesCard from "../../components/home/ServicesCard";
import FaqSection from "../../components/about/FAQ";

const ResidentialProject = () => {
  const { language } = useSelector((state) => state.language);

  // Translation objects
  const translations = {
    gb: {
      heading: "Residential Projects",
      buttonText: "About Us",
      aboutHeading: "About Our Residential Services",
      aboutText: `At Etihad Gharbia Contracting Company, we take pride in delivering high-quality residential construction and contracting services across the Kingdom of Saudi Arabia. With over a decade of experience and a track record of excellence, we provide turnkey solutions tailored to meet the unique needs of residential developers, housing authorities, and private clients.

Our team of engineers, architects, and skilled laborers work collaboratively to deliver projects on time, within budget, and with exceptional attention to detail. From standalone villas to large-scale housing compounds and apartment complexes, we ensure that every structure is built to the highest standards of quality and sustainability.`,
      includedHeading: "What's Included in Our Residential Services",
      includedItems: [
        "Turnkey construction for villas, townhouses, and apartment complexes",
        "Project design coordination and architectural planning",
        "Site preparation, excavation, and structural work",
        "Mechanical, Electrical & Plumbing (MEP) services",
        "Interior finishing including tiling, painting, and carpentry",
        "Landscaping and outdoor features",
        "Compliance with Saudi Building Codes and Vision 2030 standards",
        "On-site safety management and quality control",
      ],
      customizedHeading: "Why Choose Etihad Gharbia for Residential Projects",
      customizedItems: [
        "Experienced in delivering complex residential developments across KSA",
        "Dedicated project managers ensuring timely and efficient execution",
        "Access to in-house manpower and modern equipment fleet",
        "High-quality materials and partnerships with trusted suppliers",
        "Customizable design and construction solutions based on client needs",
        "24/7 support and transparent communication throughout the project lifecycle",
        "Sustainable and energy-efficient building practices",
        "Proven track record with prestigious clients in the public and private sectors",
      ],
    },
    sa: {
      heading: "المشاريع السكنية",
      buttonText: "معلومات عنا",
      aboutHeading: "حول خدماتنا السكنية",
      aboutText: `في شركة اتحاد غربيا للمقاولات، نفخر بتقديم خدمات بناء ومقاولات سكنية عالية الجودة في جميع أنحاء المملكة العربية السعودية. مع أكثر من عقد من الخبرة وسجل حافل بالتميز، نقدم حلولاً شاملة مصممة خصيصًا لتلبية الاحتياجات الفريدة للمطورين السكنيين وسلطات الإسكان والعملاء الخاصين.

يعمل فريقنا من المهندسين والمهندسين المعماريين والعمال المهرة بشكل تعاوني لتسليم المشاريع في الوقت المحدد، ضمن الميزانية المحددة، وباهتمام استثنائي بالتفاصيل. من الفيلات المستقلة إلى المجمعات السكنية الكبيرة ومجمعات الشقق، نضمن أن كل هيكل مبني وفقًا لأعلى معايير الجودة والاستدامة.`,
      includedHeading: "ما المدرج في خدماتنا السكنية",
      includedItems: [
        "البناء الشامل للفلل والمنازل المتلاصقة ومجمعات الشقق",
        "تنسيق تصميم المشروع والتخطيط المعماري",
        "إعداد الموقع والحفر والأعمال الهيكلية",
        "خدمات الميكانيكية والكهربائية والسباكة (MEP)",
        "تشطيب داخلي بما في ذلك البلاط والطلاء والنجارة",
        "تنسيق المواقع الخارجية والميزات الخارجية",
        "الامتثال لمواد البناء السعودية ومعايير رؤية 2030",
        "إدارة السلامة في الموقع ومراقبة الجودة",
      ],
      customizedHeading: "لماذا تختار اتحاد غربيا للمشاريع السكنية",
      customizedItems: [
        "خبرة في تنفيذ المشاريع السكنية المعقدة في جميع أنحاء المملكة",
        "مديرو مشاريع مخصصون يضمنون التنفيذ في الوقت المحدد وبكفاءة",
        "الوصول إلى القوى العاملة الداخلية وأسطول المعدات الحديثة",
        "مواد عالية الجودة وشراكات مع موردين موثوق بهم",
        "حلول تصميم وبناء قابلة للتخصيص بناءً على احتياجات العميل",
        "دعم على مدار الساعة واتصال شفاف طوال دورة حياة المشروع",
        "ممارسات بناء مستدامة وكفاءة في استخدام الطاقة",
        "سجل حافل مع عملاء مرموقين في القطاعين العام والخاص",
      ],
    },
    fr: {
      heading: "Projets Résidentiels",
      buttonText: "À propos de nous",
      aboutHeading: "À propos de nos services résidentiels",
      aboutText: `Chez Etihad Gharbia Contracting Company, nous sommes fiers de fournir des services de construction et de contrat résidentiels de haute qualité à travers le Royaume d'Arabie Saoudite. Avec plus d'une décennie d'expérience et un bilan d'excellence, nous proposons des solutions clés en main adaptées aux besoins uniques des promoteurs résidentiels, des autorités du logement et des clients privés.

Notre équipe d'ingénieurs, d'architectes et d'ouvriers qualifiés travaille en collaboration pour livrer des projets à temps, dans les limites du budget et avec une attention exceptionnelle aux détails. Des villas indépendantes aux grands ensembles résidentiels et complexes d'appartements, nous veillons à ce que chaque structure soit construite selon les normes les plus élevées de qualité et de durabilité.`,
      includedHeading: "Ce qui est inclus dans nos services résidentiels",
      includedItems: [
        "Construction clé en main pour villas, maisons mitoyennes et complexes d'appartements",
        "Coordination de la conception du projet et planification architecturale",
        "Préparation du site, excavation et travaux structurels",
        "Services mécaniques, électriques et de plomberie (MEP)",
        "Finition intérieure incluant carrelage, peinture et menuiserie",
        "Aménagement paysager et caractéristiques extérieures",
        "Conformité aux codes du bâtiment saoudiens et aux normes Vision 2030",
        "Gestion de la sécurité sur site et contrôle de la qualité",
      ],
      customizedHeading: "Pourquoi choisir Etihad Gharbia pour les projets résidentiels",
      customizedItems: [
        "Expérience dans la réalisation de développements résidentiels complexes à travers le KSA",
        "Chefs de projet dédiés assurant une exécution rapide et efficace",
        "Accès à une main-d'œuvre interne et à une flotte d'équipements modernes",
        "Matériaux de haute qualité et partenariats avec des fournisseurs de confiance",
        "Solutions de conception et de construction personnalisables selon les besoins du client",
        "Support 24/7 et communication transparente tout au long du cycle de vie du projet",
        "Pratiques de construction durables et écoénergétiques",
        "Bilan éprouvé avec des clients prestigieux des secteurs public et privé",
      ],
    },
    de: {
      heading: "Wohnprojekte",
      buttonText: "Über uns",
      aboutHeading: "Über unsere Wohnungsbaudienstleistungen",
      aboutText: `Bei der Etihad Gharbia Contracting Company sind wir stolz darauf, hochwertige Wohnungsbau- und Vertragsleistungen im gesamten Königreich Saudi-Arabien zu erbringen. Mit über einem Jahrzehnt Erfahrung und einer Erfolgsbilanz bieten wir schlüsselfertige Lösungen, die auf die besonderen Bedürfnisse von Wohnungsbauentwicklern, Wohnungsbaubehörden und privaten Kunden zugeschnitten sind.

Unser Team aus Ingenieuren, Architekten und qualifizierten Arbeitern arbeitet zusammen, um Projekte termingerecht, innerhalb des Budgets und mit außergewöhnlicher Aufmerksamkeit für Details zu liefern. Von freistehenden Villen bis hin zu großen Wohnanlagen und Apartmentkomplexen stellen wir sicher, dass jedes Gebäude nach höchsten Qualitäts- und Nachhaltigkeitsstandards gebaut wird.`,
      includedHeading: "Was in unseren Wohnungsbaudienstleistungen enthalten ist",
      includedItems: [
        "Schlüsselfertiger Bau von Villen, Reihenhäusern und Apartmentkomplexen",
        "Projektentwurfsabstimmung und architektonische Planung",
        "Geländevorbereitung, Aushub und Strukturarbeiten",
        "Mechanische, elektrische und sanitäre Dienstleistungen (MEP)",
        "Innenausbau einschließlich Fliesen, Maler- und Tischlerarbeiten",
        "Landschaftsgestaltung und Außenmerkmale",
        "Einhaltung der saudi-arabischen Bauvorschriften und Vision 2030-Standards",
        "Sicherheitsmanagement und Qualitätskontrolle vor Ort",
      ],
      customizedHeading: "Warum Etihad Gharbia für Wohnprojekte wählen",
      customizedItems: [
        "Erfahrung in der Umsetzung komplexer Wohnprojekte in ganz KSA",
        "Dedizierte Projektmanager, die eine termingerechte und effiziente Ausführung gewährleisten",
        "Zugang zu internen Arbeitskräften und modernen Geräteflotten",
        "Hochwertige Materialien und Partnerschaften mit vertrauenswürdigen Lieferanten",
        "Anpassbare Design- und Baukösungen basierend auf Kundenbedürfnissen",
        "24/7-Support und transparente Kommunikation während des gesamten Projektlebenszyklus",
        "Nachhaltige und energieeffiziente Bauweisen",
        "Bewährte Erfolgsbilanz mit renommierten Kunden aus dem öffentlichen und privaten Sektor",
      ],
    },
  };

  // Get translations for current language (default to English if language not found)
  const t = translations[language] || translations.gb;

  return (
    <>
      <AboutUsSection
        heading={t.heading}
        buttonText={t.buttonText}
      />
      <ServicesSubPages
        aboutHeading={t.aboutHeading}
        aboutText={t.aboutText}
        images={[Rimg1, Rimg2, Rimg3]}
        includedHeading={t.includedHeading}
        includedItems={t.includedItems}
        customizedHeading={t.customizedHeading}
        customizedItems={t.customizedItems}
      />
      <ServicesCard showHeading={false} showParagraph={false} />
      <FaqSection />
    </>
  );
};

export default ResidentialProject;